export default "/images/vendor/flag-icons/flags/4x3/um.svg?c3077277c5663829042b8565aa7690f5";